import {AnyAction} from 'redux';
import {ActionTypes} from '../actions/ActionTypes';
import {KumaViewDto, MenuDto,} from '../../services/Client';

export interface IKumaState {
  /** Extra links for the Kuma area */
  kumaExtraLinks: MenuDto;

  /** Requirements for the Kuma  */
  requirements: KumaViewDto[];
}

const INITIAL_STATE: IKumaState = {
  kumaExtraLinks: {},
  requirements:[]
};

export const kumaReducer = (
  state: IKumaState = INITIAL_STATE,
  action: AnyAction
): IKumaState => {
  switch (action.type) {
    case ActionTypes.RECEIVE_KUMA_EXTRA_LINKS:
      return {
        ...state,
        kumaExtraLinks: action.kumaExtraLinks,
      };
    case ActionTypes.RECEIVED_KUMA_REQUIREMENTS:
      return {
        ...state,
        requirements: action.requirements,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/kumaReducer.ts